<template>
  <div class="main-layout worker-edit-page">
    <el-card shadow="never" class="box-outter box-outter-back">
      <c-title slot="header" :title="title"></c-title>
      <div class="div-scroll" style="padding: 20px 20%">
        <c-form
          v-model="handleData"
          ref="cForm"
          :formItems="formItems"
          :formRules="formRules"
          @submit="submit"
          @resetFields="resetFields"
          labelWidth="120px"
          v-loading="handleLoading"
        >
          <div slot="custom" style="margin-bottom: 18px">
            <div style="margin-bottom: 18px">
              <el-button size="small" type="primary" @click="handleAddOptions"
                >添加</el-button
              >
            </div>
            <el-table :data="tableData" border style="width: 100%">
              <el-table-column label="测试选项" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.optionName"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="分数">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.score"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    @click="handleDeleteOptions(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </c-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import MHandle from "@/mixins/MHandle.js";
import Configs from "./data/question";
import { mapState } from "vuex";
let mHandle = MHandle({
  handleGetPath: "/welcome-forecast/test/title",
  handleInsertPath: "/welcome-forecast/test/title/save",
  handleUpdatePath: "/welcome-forecast/test/title/update",
  handleDownLoadPath: "",
  handleData: {
    name: "",
    dimension: "",
    options: [],
  },
});
export default {
  mixins: [mHandle],
  data() {
    let { formItems, formRules } = Configs(this);
    return {
      formItems,
      formRules,
      title: "",
      tableData: [
        { optionName: "没有或很少", score: 1 },
        { optionName: "少部分时间", score: 2 },
        { optionName: "相当多时间", score: 3 },
      ],
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
  },
  created() {},
  mounted() {
    let id = this.$route.params.id == "undefined" ? "" : this.$route.params.id;
    if (id) {
      this.title = "编辑";
      this.handleGet(id);
    } else {
      this.title = "新增";
    }
  },
  methods: {
    handleGetAfterFn(data) {
      this.tableData = data.options;
    },
    handleBeforeFn(data) {
      data.options = this.tableData;
      return data;
    },
    submit(fn) {
      if (this.handleData.id) {
        this.handleUpdate();
      } else {
        this.handleInsert();
      }
    },
    handleBack() {
      //   this.$router.go(-1);
      this.$router.push("/welcome/teacher/entranceTest/question");
    },
    handleAfterFn() {
      //   this.$router.go(-1);
      this.$router.push("/welcome/teacher/entranceTest/question");
    },
    resetFields() {
      //   this.$router.go(-1);
      this.$router.push("/welcome/teacher/entranceTest/question");
    },
    handleAddOptions() {
      this.tableData.push({ optionName: "", score: "" });
    },
    // 删除分数选项
    handleDeleteOptions(index) {
      this.tableData.splice(index, 1);
    },
  },
};
</script>

